<template>
  <div class="select-container" :class="isPc ? 'pc': 'mobile'">
    <template v-if="!isPc && !isMultiple">
      <van-field
        readonly
        clickable
        class="mobile-select"
        name="picker"
        :class="isDisabled ? 'disabled': ''"
        :disabled="isDisabled"
        :value="internalValue"
        @click="handelClick"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
    </template>
    <template v-else>
      <div :class="isPc ? 'body-container pc': 'body-container mobile'">
        <el-select
          class="select"
          v-model="internalValue"
          :class="isDisabled ? 'disabled': ''"
          :multiple="isMultiple"
          :placeholder="$t('microSite.form.placeholder.select')"
          :disabled="isDisabled"
          clearable
        >
          <el-option
            v-for="item in option"
            :key="item.index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
    </template>
  </div>
</template>

<script>

import _ from 'lodash'

export default {
  props: {
    value: {
    },
    title: {
      type: String,
      default: ''
    },
    option: {
      type: Array
    },
    isPc: {
      type: Boolean,
      default: true
    },
    isMultiple: {
      type: Boolean,
      default: false
    },
    isRequired: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      internalValue: '',
      showPicker: false
    }
  },
  computed: {
    columns () {
      const columns = []
      _.forEach(this.option, (item) => {
        columns.push(item.label)
      })
      return columns
    }
  },
  created () {
    this.internalValue = this.value
  },
  mounted () {
  },
  methods: {
    handelClick () {
      if (!this.isDisabled) {
        this.showPicker = true
      }
    },
    onConfirm (value) {
      this.internalValue = value
      this.showPicker = false
    }
  },
  watch: {
    value: {
      handler (val, oldVal) {
        this.internalValue = val
      },
      immediate: true
    },
    internalValue (val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.select-container {
  padding: 10px 0 0 0;

  &.pc {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .mobile-select {
    padding: 3px 10px;
    line-height: 24px;
    border: 1px solid #DCDFE6;

    &.disabled {
      background: #F5F7FA;
    }
  }

  .body-container {
    .select {
      width: 100%;
      &.disabled {
        cursor: not-allowed;
      }
    }

    &.pc {
      width: 35%;
    }
  }
}
</style>
